<template>
  <div>
    <table class="mt-12">
      <thead>
        <tr>
          <th>
            <div class="flex items-center gap-2 font-medium text-zinc-100 min-w-30">
              <Icon
                name="mdi:clock-outline"
                class="text-primary"
              />
              Date / Time
            </div>
          </th>

          <th>
            <div class="flex items-center gap-2 font-medium text-zinc-100">
              <Icon
                name="mdi:book-open-variant"
                class="text-primary"
              />
              Topic
            </div>
          </th>

          <th>
            <div class="flex items-center gap-2 font-medium text-zinc-100">
              <Icon
                name="mdi:account-group-outline"
                class="text-primary"
              />
              Lead / Q&A
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2 font-medium text-zinc-100 ">
              <Icon
                name="mdi:tag-outline"
                class="text-primary"
              />
              Type
            </div>
          </th>
          <th>
            <div class="flex items-center gap-2 font-medium text-zinc-100 ">
              <Icon
                name="mdi:clipboard-check-outline"
                class="text-primary"
              />
              Register
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in data"
          :key="index"
        >
          <td>
            <p class="font-bold">
              {{ useDateFormat(item.start, 'H:mm') }} - {{ useDateFormat(item.end, 'H:mm') }}
            </p>
            <p>{{ useDateFormat(item.start, 'DD/MM/YYYY') }}</p>
            <p>{{ useDateFormat(item.start, 'z') }}</p>
          </td>
          <td>{{ item.topic }}</td>
          <td>{{ item.lead }}</td>
          <td>
            <div class="mx-auto text-center">
              <div
                v-if="item.type === 'webinar'"
                class="text-xs bg-primary-green tracking-wide text-white inline-flex font-semibold text-nowrap rounded-full px-3 py-1 uppercase"
              >
                Insight Webinar
              </div>
              <div
                v-else-if="item.type === 'journal-club'"
                class="text-xs bg-primary tracking-wide text-white inline-flex font-semibold text-nowrap rounded-full px-3 py-1 uppercase"
              >
                Journal Club
              </div>
            </div>
          </td>
          <td>
            <NuxtLink
              :href="item.link"
              target="_blank"
              class="bg-zinc-200 hover:text-white font-medium duration-150 rounded px-3 py-1 hover:bg-primary-dark"
            >Register</NuxtLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
const limit = ref(100)
const sort = ref({ start: 1, $numeric: true })
// Use ISO string for "now"
const now = new Date().toISOString()

const where = ref({
  start: { $gt: now as unknown as number },
})

const { data } = await useAsyncData('collections-all-upcoming-journals',
  () => queryContent<JournalClubSession>('/sessions').limit(limit.value).where(where.value).sort(sort.value).find(),
  { transform: data => correctAssetRoutes(data),
    watch: [limit, sort],
  },
)

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
  })
}
</script>

<style scoped lang="css">
@reference "@/assets/css/main.css";
table {
    border-collapse: collapse;
    min-width: 400px;
}

table thead tr {
    @apply bg-primary-dark text-white text-left;
}
table th,
table td {
  @apply px-6 py-2 font-normal;
}

table tbody tr {
  @apply border-b-1 border-zinc-200;
}

table tbody tr:nth-of-type(even) {
@apply bg-zinc-100;
}

table th:first-of-type {
  @apply rounded-tl-lg;
}
table th:last-of-type {
  @apply rounded-tr-lg;
}
</style>
